import React from "react";
import PropTypes from "prop-types";
import ConservationTitle from "./ConservationTitle";
import ZoomToRegion from "../../../components/TooltipActions/ZoomToRegion";
import ConservationScore from "../../../../../models/ConservationScore";
import Track from "../../../models/Track";

function ProteinTooltip({ item, track, requestClose }) {
  return item ? (
    <>
      <ConservationTitle
        item={item}
        actions={
          <div className="tw-flex tw-items-center tw-text-sm">
            <div className="tw-w-4" />

            <ZoomToRegion
              requestClose={requestClose}
              region={item.region}
              jumpTo={track.zoomService.jumpTo}
            />
          </div>
        }
      />
    </>
  ) : null;
}

ProteinTooltip.propTypes = {
  item: PropTypes.instanceOf(ConservationScore).isRequired,
  track: PropTypes.instanceOf(Track).isRequired,
  requestClose: PropTypes.func.isRequired,
};

ProteinTooltip.defaultProps = {};

export default ProteinTooltip;
